module.exports = __webpack_public_path__ + "img/logo-icon.4039e9c5.png";